/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Navigation_MenuInputs */

const en_navigation_menu = /** @type {(inputs: Navigation_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigation menu`)
};

const fr_navigation_menu = /** @type {(inputs: Navigation_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu de navigation`)
};

/**
* | output |
* | --- |
* | "Navigation menu" |
*
* @param {Navigation_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const navigation_menu = /** @type {((inputs?: Navigation_MenuInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navigation_MenuInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_navigation_menu(inputs)
	return fr_navigation_menu(inputs)
});